import { Link as RemixLink } from "@remix-run/react";
import { Box, Button, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { FaRegCreditCard } from "react-icons/fa";

import { Paper } from "#app/components/index.jsx";
import { getOfferCopy } from "#app/config/freeAccessOffers.js";
import { OfferPill } from "./OfferPill.jsx";

/**
 * Closing CTA for partner pages — a card-framed, richer sibling of the generic
 * FreeToTrySection (partners get something more compelling than a flat band).
 * Sponsored partners surface their offer (gift pill + body copy); everyone else
 * gets the "Free to start" framing. The CTA jumps to the on-page calendar.
 */
export function PartnerCta({
  name,
  body,
  freeAccessOffer,
  ctaTo = "#calendar",
}) {
  const offer = getOfferCopy(freeAccessOffer);

  return (
    <Paper
      borderRadius="xl"
      py={{ base: 8, md: 12 }}
      px={{ base: 6, md: 12 }}
      w="100%"
      maxW="container.lg"
      mx="auto"
      borderTopWidth="3px"
      borderTopColor="accent"
      textAlign="center"
    >
      <VStack spacing={5} maxW="container.sm" mx="auto">
        {offer ? (
          <OfferPill label={offer.pill} />
        ) : (
          <Text
            color="accent"
            textTransform="uppercase"
            fontWeight="bold"
            letterSpacing="wide"
            fontSize="sm"
          >
            Free to start
          </Text>
        )}

        <Heading
          as="h2"
          size={{ base: "sm", md: "md" }}
          fontWeight="extrabold"
          letterSpacing="tight"
          lineHeight="1.15"
        >
          Start watching {name}
        </Heading>

        {body && (
          <Text color="muted" fontSize={{ base: "md", md: "lg" }}>
            {body}
          </Text>
        )}

        <Button
          variant="primary"
          size="lg"
          fontWeight="bold"
          as={RemixLink}
          to={ctaTo}
          rightIcon={<ArrowForwardIcon />}
        >
          Check available dates
        </Button>

        <HStack color="muted" fontSize="sm" spacing={2}>
          <Box as={FaRegCreditCard} boxSize="14px" aria-hidden="true" />
          <Text>No credit card required &middot; cancel anytime</Text>
        </HStack>
      </VStack>
    </Paper>
  );
}
